const Community = () => (
  <svg height="30" viewBox="0 0 30 30" width="30" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <clipPath id="clipPath">
        <rect
          data-name="Rectangle 210"
          fill="#fff"
          height="30"
          id="Rectangle_210"
          transform="translate(23441 12769)"
          width="30"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#clipPath)" id="community" transform="translate(-23441 -12769)">
      <g data-name="Calque 2" id="Calque_2" transform="translate(23441 12769)">
        <g data-name="Calque 1" id="Calque_1">
          <rect data-name="Rectangle 207" fill="none" height="30" id="Rectangle_207" width="30" />
          <circle cx="15" cy="15" data-name="Ellipse 138" fill="none" id="Ellipse_138" r="15" transform="translate(0 0)" />
          <line data-name="Ligne 289" fill="none" id="Ligne_289" x2="30" y2="30" />
          <line data-name="Ligne 290" fill="none" id="Ligne_290" x1="30" y2="30" />
          <line data-name="Ligne 291" fill="none" id="Ligne_291" transform="translate(0 15)" x2="30" />
          <line data-name="Ligne 292" fill="none" id="Ligne_292" transform="translate(0 7.497)" x2="30" />
          <line data-name="Ligne 293" fill="none" id="Ligne_293" transform="translate(0 22.501)" x2="30" />
          <line data-name="Ligne 294" fill="none" id="Ligne_294" transform="translate(15)" y2="30" />
          <line data-name="Ligne 295" fill="none" id="Ligne_295" transform="translate(7.497)" y2="30" />
          <line data-name="Ligne 296" fill="none" id="Ligne_296" transform="translate(22.501)" y2="30" />
          <rect
            data-name="Rectangle 208"
            fill="none"
            height="21.218"
            id="Rectangle_208"
            transform="translate(4.391 4.391)"
            width="21.218"
          />
          <circle
            cx="10.609"
            cy="10.609"
            data-name="Ellipse 139"
            fill="none"
            id="Ellipse_139"
            r="10.609"
            transform="translate(4.391 4.391)"
          />
          <rect
            data-name="Rectangle 209"
            fill="none"
            height="15.004"
            id="Rectangle_209"
            transform="translate(7.497 7.497)"
            width="15.004"
          />
          <circle
            cx="7.501"
            cy="7.501"
            data-name="Ellipse 140"
            fill="none"
            id="Ellipse_140"
            r="7.501"
            transform="translate(7.499 7.499)"
          />
          <path
            d="M19.963,4.764A1.557,1.557,0,0,1,20.58,7.75a1.445,1.445,0,0,1-.6.127,1.556,1.556,0,0,1-1.445-.98c-.057-.152-.094-.311-.148-.493L15.253,5.74c-.326,1.528-.637,3.016-.969,4.553A10.855,10.855,0,0,1,20,12.121a2.2,2.2,0,0,1,1.479-.589h.163a2.164,2.164,0,0,1,1.968,1.626,2.189,2.189,0,0,1-.975,2.4c-.093.06-.208.2-.2.289a5.068,5.068,0,0,1-2.374,4.613,9.575,9.575,0,0,1-4.285,1.709,12.791,12.791,0,0,1-2.008.162,11.312,11.312,0,0,1-3.864-.668,7.541,7.541,0,0,1-3.947-2.886,4.257,4.257,0,0,1-.733-2.81.4.4,0,0,0-.22-.434,2.164,2.164,0,1,1,2.437-3.565.3.3,0,0,0,.419.017,10.3,10.3,0,0,1,5.025-1.639c.579-.043.578-.032.694-.582q.466-2.222.936-4.441c.067-.318.192-.455.441-.455a1.033,1.033,0,0,1,.219.027c1.059.224,2.118.443,3.174.679a.528.528,0,0,0,.117.015.293.293,0,0,0,.255-.16,1.528,1.528,0,0,1,1.25-.662M17.2,16.742a1.5,1.5,0,0,0,1.515-1.5,1.528,1.528,0,0,0-1.506-1.528H17.2a1.554,1.554,0,0,0-1.518,1.528,1.528,1.528,0,0,0,1.509,1.5H17.2m-6.76,0a1.528,1.528,0,0,0,1.528-1.505,1.554,1.554,0,0,0-1.52-1.528h0a1.528,1.528,0,0,0-1.506,1.5,1.5,1.5,0,0,0,1.5,1.528h0m3.649,3.66c.276-.033.814-.067,1.339-.167a3.937,3.937,0,0,0,1.943-.875c.22-.2.255-.428.1-.6a.318.318,0,0,0-.243-.109.637.637,0,0,0-.348.127,4.315,4.315,0,0,1-.764.452,5.621,5.621,0,0,1-2.189.416c-.182,0-.365-.008-.549-.022a4.367,4.367,0,0,1-2.674-.891.382.382,0,0,0-.246-.1.365.365,0,0,0-.271.127.336.336,0,0,0,.039.531,5.565,5.565,0,0,0,.964.615,7,7,0,0,0,2.9.49M19.963,4a2.26,2.26,0,0,0-1.7.764C17.534,4.6,16.8,4.449,16.1,4.3l-.764-.16A1.8,1.8,0,0,0,14.95,4.1a1.179,1.179,0,0,0-1.188,1.061L12.834,9.58h0A11.055,11.055,0,0,0,7.669,11.2a2.924,2.924,0,0,0-3.216,4.881,5.038,5.038,0,0,0,.87,3.114,8.244,8.244,0,0,0,4.329,3.183,12.125,12.125,0,0,0,4.121.713,13.666,13.666,0,0,0,2.126-.171,10.223,10.223,0,0,0,4.621-1.85,5.8,5.8,0,0,0,2.7-4.983,2.928,2.928,0,0,0-1.511-5.31q-.108-.008-.218-.008a2.844,2.844,0,0,0-1.495.424,11.359,11.359,0,0,0-4.77-1.584l.353-1.655.278-1.3,1.94.412c.013.037.027.075.041.113a2.321,2.321,0,0,0,2.158,1.47,2.209,2.209,0,0,0,.914-.2A2.321,2.321,0,0,0,19.963,4Z"
            data-name="Tracé 1537"
            fill="#fff"
            id="Tracé_1537"
            transform="translate(1.171 1.454)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Community;
